import React, { useEffect, useState } from 'react';
import { View, Dimensions, ScrollView, ActivityIndicator, FlatList, Image } from 'react-native';
import { Avatar, Icon } from 'react-native-elements';
import getEnvVars from '../../env';
const { APP_VERSION } = getEnvVars()
import Modal from 'modal-enhanced-react-native-web';
import Colors from '../../constants/Colorsv2';
import Styles from '../../constants/Styles';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { MyPlayerProps, PlayerBalanceProps } from '../../store/types/auth_svc';
import { useDispatch } from 'react-redux';
import { V1_SHOW_PROFILE, V1_SHOW_WALLET } from '../../store/actionsv1/types';
import Switch from '../../screensV1/Social/components/Switch';
import { updatePlayer } from '../../store/actionsv1/player';

type SettingType = { title:string, icon:string, type:string, stack:string, page:string, params?:any }
const placeHolderSetting:SettingType = { title:'na', icon:'na', type:'na', stack:'na', page:'na', params: {} }

type AccountModalProps = { 
    navigation:any,
    market_type: string,
    player: MyPlayerProps,
    player_balance: PlayerBalanceProps;
    headerHeight:number;
    backgroundColor:string;
    width:number
    no_help:boolean,
    isVisible:boolean;
    closeModal: any;
    onSignOut: () => void;
    onChangePreference: (market_type:string) => void
 }

function AccountModal({navigation, market_type, no_help, width, backgroundColor, player, player_balance, headerHeight, isVisible, closeModal, onSignOut, onChangePreference}:AccountModalProps) {
    const [ selectedSetting, setSelectedSetting ] = useState(placeHolderSetting)
    const [ beScore, setBeScore ] = useState(999)
    
    const dispatch = useDispatch();

    let settings:SettingType[] = [
        { title: 'My Performance History', icon:'trending-up', type:'perfMarket', stack:'HomeStack', page: 'OverallMetrics' }, 
        { title: 'Refer & Earn', icon:'user-plus', type:'refer', stack: 'HomeStack', page: 'InviteFriends' }, 
        { title: 'Rebates', icon:'gift', type:'rebate', stack: 'HomeStack', page: 'ActivityRebates' },
        { title: 'My Polls', icon:'bar-chart', type:'refer', stack: 'HomeStack', page: 'ManagePolls' },
        { title: 'Log Out', icon:'log-out', type:'logout', stack:'HomeStack', page:'Dashboard' },
    ]

    if(player?.type != 'premium'){
        settings = settings.filter(s => s.title != 'My Polls')
    }


    const handleActionOnClose = () => {
        if(selectedSetting.type === 'na'){ return } //Do Nothing
        if(selectedSetting.type == 'wallet'){
            return dispatch({ type: V1_SHOW_WALLET, show_wallet: { visible: true } })
        }
        if(selectedSetting.type === 'help'){
            return window.open('https://support.bettoredge.com', '_blank')
        }
        if(selectedSetting.type === 'marketType'){ 
            setSelectedSetting(placeHolderSetting)
            if(!onChangePreference){ return }
            return onChangePreference(selectedSetting.page) 
        }
        if(selectedSetting.type === 'logout'){ 
            if(!onSignOut){ return }
            setSelectedSetting(placeHolderSetting)
            return onSignOut() 
        }
        if(selectedSetting.type === 'vouch'){ 
            setSelectedSetting(placeHolderSetting)
            return navigation.navigate('AuthStack', { screen:'VouchStatus', params: {} })
         }
         if(selectedSetting.type == 'premium'){
            setSelectedSetting(placeHolderSetting)
            return navigation.navigate('AuthStack', { screen: 'Premium' })
         }
        const navDetails = { ...selectedSetting}
        setSelectedSetting(placeHolderSetting)
        return navigation.navigate(navDetails.stack, { screen: navDetails.page, initial:false, params: navDetails.params })
    }

    const handleSelect = (setting:SettingType) => {
        setSelectedSetting(setting)
        closeModal()
    }

    const handleChangeMarketType = (market_type:'FOR_MONEY'|'FREE') => {
        setSelectedSetting({ title: 'na', icon:'na', type:'marketType', stack:'HomeStack', page:market_type, params:{} })
        closeModal()
    }
 
    const handleAddFunds = () => {
        if(player.vouched_status !== 'verified'){
            setSelectedSetting({ title: 'na', icon:'na', type:'vouch', stack:'AuthStack', page:'VouchStatus', params:{} })
        } else {
            setSelectedSetting({ title: 'na', icon:'na', type:'wallet', stack:'HomeStack', page:'ACH', params:{} })
        }
        return closeModal()
    }

    const handleEditProfile = () => {
        dispatch({ type: V1_SHOW_PROFILE, show_profile: { visible: true } })
        return closeModal()
    }

    const handleProfilePicPress = () => {
        setSelectedSetting({ title: 'na', icon:'na', type:'profile', stack:'SocialStack', page:'SocialProfile', params:{ player_id: player.player_id } })
        closeModal()
    }
    const handleBEScorePress= () => {
        setSelectedSetting({ title: 'na', icon:'na', type:'score', stack:'HomeStack', page:'BeScore', params:{ market_type } })
        closeModal()
    }
    
    const renderSettings = ({ item }) => {
        if(item.type === 'admin' && player.role !== 'admin'){ return (<></>) }
        return (
            <TouchableOpacity style={{flexDirection:'row', alignItems:'center', marginBottom:30}} onPress={() => handleSelect(item)}>
                <Icon containerStyle={{marginRight:20}} name={item.icon} type='feather' size={24} color={Colors.brand.electric} />
                <Text style={Styles.textStyles.blackRegularLeft16}>{item.title}</Text>
            </TouchableOpacity>
        )
    }

    if(!player || !player_balance){ return <></> }

    return (
        <Modal isVisible={isVisible} propagateSwipe backdropOpacity={0} style={{ flex:1, margin:0, justifyContent: 'flex-start', alignItems:'center'}} animationIn='slideInDown' animationOut='slideOutUp' animationOutTiming={600}
            onSwipeComplete={() => closeModal()} onBackdropPress={() => closeModal()} onModalHide={handleActionOnClose}>
            <ScrollView style={{ ...localStyles.modalStyle, width, marginTop:headerHeight }}>
                <View style={{backgroundColor, padding:5, borderBottomLeftRadius:57, borderBottomRightRadius:57}}>
                    <TouchableOpacity style={{justifyContent:'center', alignItems:'center'}} onPress={() => handleProfilePicPress()}>
                        <Avatar size='large' rounded title={player.first_name[0]} source ={player.profile_pic?{ uri: player.profile_pic }:require('../../assets/images/default-avatar.png')} />
                    </TouchableOpacity>
                    <Text style={Styles.textStyles.accountName}>{player.first_name} {player.last_name}</Text>
                    <TouchableOpacity native_id='premium' style={{ margin:5, alignSelf:'center', flexDirection:'row', alignItems:'center', justifyContent:'center', padding:10, backgroundColor:Colors.incentive.gold, borderRadius:22 }} onPress={() => {
                        handleSelect({ title: 'Premium', icon:'trending-up', type:'premium', stack:'Auth', page: 'Premium' })
                    }}>
                        <Text size={16} color={Colors.shades.white} weight='bold'>{player.type == 'premium'? "Manage Premium": "Try Premium!"}</Text>
                    </TouchableOpacity>
                    <View style={{flex:1, flexDirection:'row', marginTop:10, alignItems:'center'}}>
                        <TouchableOpacity style={{flex:2/5, justifyContent:'flex-end'}} onPress={() => handleChangeMarketType('FOR_MONEY')}>
                            <Text style={market_type==='FOR_MONEY'?Styles.textStyles.whiteBoldRight20:Styles.textStyles.whiteRegularRight20}>${player_balance.balance.toFixed(2)}</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{padding:10, flex:1/5}} onPress={() => handleChangeMarketType(market_type==='FOR_MONEY'?'FREE':'FOR_MONEY')}>
                            <View style={{flex:1, flexDirection:'row', flexGrow:1, backgroundColor:Colors.shades.white, borderRadius:25, padding:3}}>
                                <View style={{flex:1/2, borderRadius:100, backgroundColor:market_type==='FOR_MONEY'?Colors.highlights.highlight400:'transparent', height:28, width:28}} />
                                <View style={{flex:1/2, borderRadius:100, backgroundColor:market_type==='FREE'?Colors.highlights.highlight400:'transparent', height:28, width:28}} />
                            </View>
                        </TouchableOpacity>
                        <TouchableOpacity style={{flex:2/5, justifyContent:'flex-start'}} onPress={() => handleChangeMarketType('FREE')}>
                            <Text style={market_type==='FREE'?Styles.textStyles.whiteBoldLeft20:Styles.textStyles.whiteRegularLeft20}>E{player_balance.free_market_balance.toFixed(2)}</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={{flexDirection:'row', justifyContent:'center', alignItems:'center', margin:10}}>
                        <TouchableOpacity style={{ marginRight:4, flexDirection:'row', alignItems:'center', padding:8, paddingRight:20, paddingLeft:20, borderRadius:22, borderWidth:1, borderColor:Colors.shades.white}}  onPress={() => handleAddFunds()}>
                            <Icon containerStyle={{marginRight:5}} name='dollar-sign' type='feather' color={Colors.shades.white} size={14}/>
                            <Text style={Styles.textStyles.whiteBoldCenter14}>Wallet</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ marginLeft:4, flexDirection:'row', alignItems:'center', padding:8, paddingRight:20, paddingLeft:20, borderRadius:22, borderWidth:1, borderColor:Colors.shades.white}}  onPress={() => handleEditProfile()}>
                            <Icon containerStyle={{ marginRight:5 }} name='user' type='feather' color={Colors.shades.white} size={14}/>
                            <Text style={Styles.textStyles.whiteBoldCenter14}>Edit Profile</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                <View style={{ marginTop:10, marginLeft:20, marginRight:20, backgroundColor:Colors.brand.mint, borderRadius:8  }}>
                    <View style={{ flexDirection:'row', alignItems:'center', margin:10, padding:10, borderBottomWidth:1, borderColor:Colors.shades.white}}>
                        <Image
                            source={{ uri: require('../../assets/images/help_james.png') }}
                            style={{ height:50, width:50, marginLeft:5 }}
                            resizeMode='cover'
                        />
                        <View style={{ flex:1, marginLeft:5, marginRight:5 }}>
                            <Text size={14} color={Colors.brand.midnight} weight='bold'>Hey! I'm James your guide.</Text>
                            <Text style={{ marginTop:5 }} size={12} color={Colors.brand.midnight} weight='semibold'>{no_help?'Guided prompts are turned off.':'Guided prompts are currently on.'} Press the toggle to change! </Text>
                        </View>
                        <Switch 
                            value={player.guide_me ? true: false}
                            switch_type='on_off'
                            onChange={(value) => {
                                if(!player){ return }
                                dispatch(updatePlayer({...player, guide_me: value}))
                            }}
                        />
                    </View>
                    <View style={{ padding:10, paddingTop:0, flexDirection:'row', alignItems:'center' }}>
                        <TouchableOpacity style={{ flex:1, flexDirection:'row', alignItems:'center', borderRadius:8, justifyContent:'center', marginRight:5, backgroundColor:Colors.shades.white, padding:10 }} onPress={() => {
                            handleSelect({ title: 'Help Center', icon:'alert-circle', type:'help', stack:'HomeStack', page: 'GuideSelect', params: {} })
                        }}>
                            <Icon name='help-circle' type='feather' color={Colors.brand.electric} size={16} />
                            <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.electric} weight='semibold'>Help Center</Text>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ flex:1, flexDirection:'row', alignItems:'center', borderRadius:8, justifyContent:'center', marginLeft:5, backgroundColor:Colors.shades.white, padding:10 }} onPress={() => {
                            handleSelect({ title: 'Chat With Support', icon:'message-circle', type:'chat', stack:'SocialStack', page:'DirectMessage', params:{ other_id: '345' } })
                        }}>
                            <Icon name='message-circle' type='feather' color={Colors.brand.electric} size={16} />
                            <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.electric} weight='semibold'>Chat With Support</Text>
                        </TouchableOpacity>
                    </View>
                </View>
                <View style={{padding:20}}>
                    <FlatList data={settings} renderItem={renderSettings} keyExtractor={(item) => item.type}/>
                    <Text size={12} color={Colors.brand.midnight}>v{APP_VERSION}</Text>
                </View>
            </ScrollView>
        </Modal>
    )
}

const localStyles = {
    modalStyle: { backgroundColor: Colors.shades.white },
    actionSectionStyle: { padding:15, justifyContent:'center', alignItems:'center' },
}


function areEqual(prevProps:any, nextProps:any) {
    if(!prevProps.isVisible && !nextProps.isVisible){ return true }
    let allEqual:boolean = true
    if(prevProps.no_help != nextProps.no_help){ return false }
    if(prevProps.player != nextProps.player){ return false }
    if(prevProps.isVisible !== nextProps.isVisible){ allEqual = false }
    if(prevProps.market_type !== nextProps.market_type){ allEqual = false }
    if(prevProps.balance !== nextProps.balance){ allEqual = false }
    if(prevProps.free_market_balance !== nextProps.free_market_balance){ allEqual = false }
    if(prevProps.width != nextProps.width){ allEqual = false }
    return allEqual
}

export default React.memo(AccountModal, areEqual)